import React from 'react'
import styled from 'styled-components'
import TextSpan from "./textSpan";

const HomeInfo = () => {
    const first = 'Dawlet'.split("");
    const last = 'Kenesbaev'.split("");
  return  (
    <Upper>
    <div className="box">
    <div className="first">
        {first.map((letter,index) =>{
        return (
            <TextSpan key={index}>
                {letter}
            </TextSpan>
        )
        })}
    </div>
    <div className="last">
        {last.map((letter,index) =>{
        return (
            <TextSpan key={index}>
                {letter}
            </TextSpan>
        )
        })}
    </div>
    </div>
    <h3 className="">Front-end Developer <br></br> 20 years old</h3>
    </Upper>
  )
}
const Upper = styled.div`
  color:  black;
  font-weight:700;
  padding:0 70px;
  width: 100%;
  display:flex;
  justify-content:space-between;
  align-items:center;
  @media (max-width: 830px) {
     flex-direction:column;
     align-items: start;

  }
  .first {
    width:50%;
    display:flex;
    justify-content:space-between;
    align-items:center;
    @media (max-width: 830px) {
      width: 50%;
      font-size: 55px;
    }
  }
  .last {
    width:55%;
    display:flex;
    justify-content:space-between;
    align-items:center;
    @media (max-width: 830px) {
      width: 60%;
      font-size: 55px;
    }
  }
  .box {
    width:60%;
    margin: 50px 0;
    @media (max-width: 830px) {
      width:100%;
    }
  }
  h3 {
    font-size: 26px;
    font-weight: 600;
    text-align: left;
   
  }
`
export default HomeInfo